import { forwardRef } from "react";
import classNames from "classnames";
import { withClickOutside } from "../../../../hoc/withClickOutside";
import Menu from "../../../../UI/Menu/Menu";
import CategoriesMegaDropdown from "./CategoriesMegaDropdown/CategoriesMegaDropdown";
import classes from "./NavSuggestions.module.css";

const NavSuggestions = forwardRef((props, ref) => {
  const { open, setOpen } = props;
  const megaMenuOpenToggleHandler = () => {
    setOpen((prevOpen) => !prevOpen);
  };
  const megaMenuClosedHandler = () => {
    setOpen(false);
  };

  return (
    <div
      className={classNames(classes["nav-suggestions"], {
        [classes["nav-suggestions--active"]]: open,
      })}
      ref={ref}
    >
      <button
        className={classes["nav-suggestions__btn"]}
        onClick={megaMenuOpenToggleHandler}
      >
        <Menu />
        <p className={classes["nav-suggestions__text"]}>بتدور على ايه ؟</p>
      </button>
      {open && <CategoriesMegaDropdown closeMegaMenu={megaMenuClosedHandler} />}
    </div>
  );
});

export default withClickOutside(NavSuggestions);
